import axiosInstance from "@/api/axios";
import React, {useEffect, useState, useContext} from "react";
import {LanguageContext} from "@/context/LanguageContext";
import {
    AiFillDatabase,
    AiFillLeftSquare,
    AiFillRightSquare,
} from "react-icons/ai";
import "./Waste-Items.css";
import {FiFilter} from 'react-icons/fi';
import {useTranslation} from "react-i18next";

const WasteItems = (props) => {
    const {id: propId, value, wastevalue, datevalue_, selectedButton_} = props;
    const [wasteitem, setWasteItem] = useState([]);
    const [pagination, setPagination] = useState(null);
    const [pagenumber, setPageNumber] = useState(null);
    const {language} = useContext(LanguageContext);
    const [sortDirectionWeight, setSortDirectionWeight] = useState("default");
    const [sortDirectionTime, setSortDirectionTime] = useState("default");
    const [withcalendar, setWithcalendar] = useState(false);
    const [sortBy, setSortBy] = useState('weight');
    const [counter, setCounter] = useState(1);
    const [loading, setLoading] = useState(false);
    const [currentId, setCurrentId] = useState(propId);
    const [currentFilter, setCurrentFilter] = useState('');
    const {t} = useTranslation();
    const [datevalue, setDateValue] = useState([
        {
            startDate: null,
            endDate: null,
            key: 'selection'
        }
    ]);

    useEffect(() => {
        resetDates();
    }, [value]);

    const resetDates = () => {
        setDateValue([
            {
                startDate: null,
                endDate: null,
                key: 'selection'
            }
        ]);
    };

    const handleDateValueChange = (newDateValue) => {
        setDateValue(newDateValue);
       // setCalendarClick(false)
    }

    console.log("wasteitem value:", value);
    console.log("wasteitem wastevalue:", wastevalue);
    console.log("wasteitem datevalue_", datevalue_);
    console.log("wasteitem propId", propId);

    const getAllBinItems = (page = 1) => {
        setLoading(true);
        axiosInstance
            .get("/wasteitem", {
                params: {
                    id: "all",
                    value: value,
                    wastevalue: wastevalue,
                    weight: sortDirectionWeight,
                    time: sortDirectionTime,
                    page: page,
                },
            })
            .then((response) => {
                setLoading(false);
                setWasteItem(response.data.results);
                setPagination(response.data);
                setPageNumber(Math.ceil(response.data.count / 5));
                setCounter(page);
                setCurrentId("all");
            })
            .catch((error) => {
                console.error(error);
                setLoading(false);
            });
    };

    const handleFilterChange = (value) => {
        setCurrentFilter(value);
        switch (value) {
            case 'weightAsc':
                setSortBy('weight');
                setSortDirectionWeight(true);
                break;
            case 'weightDesc':
                setSortBy('weight');
                setSortDirectionWeight(false);
                break;
            case 'timeAsc':
                setSortBy('time');
                setSortDirectionTime(true);
                break;
            case 'all':
                getAllBinItems();
                return;
            case 'timeDesc':
                setSortBy('time');
                setSortDirectionTime(false);
                break;
            case 'clear':
                setSortBy('');
                setSortDirectionTime("default");
                setSortDirectionWeight("default");
                break;
        }
        if (selectedButton_ === 'custom') {
            fetchWasteDataWithCalendar(currentId, 1);
        } else {
            fetchWasteData(currentId, 1);
        }

    };

    const handlePrevClick = () => {
        if (pagination && pagination.previous) {
            const prevPage = counter - 1;
            setCounter(prevPage);
            if (selectedButton_ === 'custom') {
                fetchWasteDataWithCalendar(currentId, 1);
            } else {
                fetchWasteData(currentId, 1);
            }
        }
    };

    const handleNextClick = () => {
        if (pagination && pagination.next) {
            const nextPage = counter + 1;
            setCounter(nextPage);
            if (selectedButton_ === 'custom') {
                fetchWasteDataWithCalendar(currentId, nextPage);
            } else {
                fetchWasteData(currentId, nextPage);
            }
            //fetchWasteData(currentId, nextPage);
        }
    };

    const fetchWasteData = (id, page = 1) => {
        setLoading(true);
        axiosInstance.get("/wasteitem", {
            params: {
                id: id,
                value: value,
                wastevalue: wastevalue,
                weight: sortDirectionWeight,
                time: sortDirectionTime,
                page: page,
            },
        })
            .then((response) => {
                setWasteItem(response.data.results);
                setPagination(response.data);
                setPageNumber(Math.ceil(response.data.count / 5));
                setLoading(false);
            })
            .catch((error) => {
                console.error(error);
                setLoading(false);
            });
    };


    const fetchWasteDataWithCalendar = (id, page = 1) => {

        console.log("fetchWasteDataWithCalendar :", datevalue_[0]);
        let startDate = new Date(datevalue_[0].startDate);
        let endDate = new Date(datevalue_[0].endDate);
        setWithcalendar(true);


        const defaultDateString = 'Thu Jan 01 1970 03:00:00 GMT+0300 (East Africa Time)';

        if (startDate.toString() === defaultDateString) {
            startDate = null;
        }

        if (endDate.toString() === defaultDateString) {
            endDate = null;
        }

        console.log("startDate & endDate : " , startDate + " "+  endDate)
        if (startDate && endDate) {

            setLoading(true);
            console.log("Waste Items API params: " , {
                    id: id,
                    value: value,
                    wastevalue: wastevalue,
                    weight: sortDirectionWeight,
                    time: sortDirectionTime,
                    page: page,
                    startDate: startDate,
                    endDate: endDate,
                    withcalendar: selectedButton_ === 'custom' ? true : false ,

                });

            axiosInstance.get("/wasteitem", {
                params: {
                    id: id,
                    value: value,
                    wastevalue: wastevalue,
                    weight: sortDirectionWeight,
                    time: sortDirectionTime,
                    page: page,
                    startDate: startDate.toString(),
                    endDate: endDate.toString(),
                    withcalendar: selectedButton_ === 'custom' ? true : false ,
                },
            })
                .then((response) => {
                    setWasteItem(response.data.results);
                    setPagination(response.data);
                    setPageNumber(Math.ceil(response.data.count / 5));
                    setLoading(false);
                })
                .catch((error) => {
                    console.error(error);
                    setLoading(false);
                });

        } else {

            setLoading(true);
            axiosInstance.get("/wasteitem", {
                params: {
                    id: id,
                    value: value,
                    wastevalue: wastevalue,
                    weight: sortDirectionWeight,
                    time: sortDirectionTime,
                    page: page,
                },
            })
                .then((response) => {
                    setWasteItem(response.data.results);
                    setPagination(response.data);
                    setPageNumber(Math.ceil(response.data.count / 5));
                    setLoading(false);
                })
                .catch((error) => {
                    console.error(error);
                    setLoading(false);
                });

        }


    }

    useEffect(() => {
        if (propId !== currentId) {
            setCurrentId(propId);
            setCurrentFilter('');
            setCounter(1);
            if (propId === "all") {
                getAllBinItems();
            } else {
                if (selectedButton_ === 'custom') {
                    fetchWasteDataWithCalendar(propId, 1);
                } else {
                    fetchWasteData(propId, 1);
                }
            }
        }
    }, [propId, value, wastevalue, datevalue_, currentId]);

    useEffect(() => {
        if (currentId === "all") {
            getAllBinItems(counter);
        } else {
            if (selectedButton_ === 'custom') {
                fetchWasteDataWithCalendar(currentId, counter);
            } else {
                fetchWasteData(currentId, counter);
            }
        }
    }, [sortDirectionTime, sortDirectionWeight, wastevalue, datevalue_]);

    const translateWasteToDutch = (text) => {
        const translations = {
            "organic": "Biologisch",
            "PMD": "PMD",
            "paper": "papier",
            "rest": "Resterend"
        };
        return translations[text] || text;
    }

    return (
        <div className="w-full">
            {/* Filter Section */}
            <div className="mb-4 flex justify-end">
                <select
                    className="text-sm p-2 border rounded-md hover:text-plaex-green focus:outline-none focus:ring-2 focus:ring-green-500"
                    onChange={(e) => handleFilterChange(e.target.value)}
                    value={currentFilter}
                >
                    <option value="" disabled>
                        <FiFilter className="inline mr-2"/>
                        {t('sortlabel')}
                    </option>
                    <option value="all">{t('alllabel')}</option>
                    <option value="weightAsc">{t('weightascendinglabel')}</option>
                    <option
                        value="weightDesc">{t('weightdescendinglabel')}</option>
                    <option value="timeAsc">{t('dateascendinglabel')}</option>
                    <option value="timeDesc">{t('datedescendinglabel')}</option>
                    <option value="clear">{t('clearfilterlabel')}</option>
                </select>
            </div>

            {/* Loading Indicator */}
            {loading ? (
                <div className="text-center p-7">
                    <span className="text-gray-500">{t('loading')}</span>
                </div>
            ) : (
                <>
                    {/* Table Section */}
                    <div className="overflow-x-auto">
                        <table className="w-full border-collapse">
                            <thead>
                            <tr className="bg-gray-100 dark:bg-gray-700">
                                <th className="p-2 text-left">{t('binlabel')}</th>
                                <th className="p-2 text-left">{t('typelabel')}</th>
                                <th className="p-2 text-left">{t('weightlabel')}</th>
                                <th className="p-2 text-left">{t('namelabel')}</th>
                                <th className="p-2 text-left">{t('datelabel')}</th>
                                <th className="p-2 text-left">{t('timelabel')}</th>
                            </tr>
                            </thead>
                            <tbody>
                            {wasteitem && wasteitem.map((row) => {
                                // Split and extract date/time correctly
                                const [date, time] = row.time_collected.split("T");
                                const cleanTime = time.split("+")[0].split(".")[0]; // Removes timezone & microseconds


                                return (
                                    <tr key={row.bin.unique_identifier} className="border-b dark:border-gray-600">
                                        <td className="p-2 uppercase">{row.bin.unique_identifier}</td>
                                        <td className="p-2">{language === 'Dutch' ? translateWasteToDutch(row.waste_type) : row.waste_type === "rest" ? "Residual" : row.waste_type}</td>
                                        <td className="p-2">{Math.ceil(row.waste_weight)}g</td>
                                        <td className="p-2">{row.sub_class_waste_type === "" ? "unidentified" : row.sub_class_waste_type}</td>
                                        <td className="p-2">{date}</td>
                                        <td className="p-2">{cleanTime}</td>
                                    </tr>

                                );
                            })}
                            </tbody>
                        </table>
                    </div>

                    {/* Pagination Section */}
                    {pagination && (
                        <div className="flex items-center justify-center mt-4 space-x-4">
                            <button
                                disabled={!pagination.previous}
                                onClick={handlePrevClick}
                                className="p-2 rounded-lg text-gray-500 disabled:opacity-50"
                            >
                                <AiFillLeftSquare className="text-2xl"/>
                            </button>
                            <span className="text-sm">
                {counter} of {pagenumber}
              </span>
                            <button
                                disabled={!pagination.next}
                                onClick={handleNextClick}
                                className="p-2 rounded-lg text-green-500 disabled:opacity-50"
                            >
                                <AiFillRightSquare className="text-2xl"/>
                            </button>
                        </div>
                    )}

                    {/* No Data Section */}
                    {!pagination && wasteitem.length === 0 && (
                        <div className="text-center p-7">
                            <div className="flex flex-col items-center text-gray-400">
                                <AiFillDatabase className="text-4xl mb-2"/>
                                <span className="text-sm">{t('nodataselected')}</span>
                            </div>
                        </div>
                    )}
                </>
            )}
        </div>
    );
};

export default WasteItems;
